import { Injectable } from '@angular/core';
import { ICache } from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthCacheService implements ICache {
  private readonly pId = 'a801160f-14ba-46b9-8c56-f0dc42a5272e';
  private readonly prefix = `supplier-portal-${this.pId}`;

  get<T = unknown>(key: string): T | undefined {
    const item = localStorage.getItem(this.prefix + key);
    if (!item) {
      return undefined;
    }
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error('Failed to parse stored cache item', error);
      return undefined;
    }
  }

  set<T = unknown>(key: string, value: T): void {
    try {
      const serialized = JSON.stringify(value);
      localStorage.setItem(this.prefix + key, serialized);
    } catch (error) {
      console.error('Failed to store cache item', error);
    }
  }

  remove(key: string): void {
    localStorage.removeItem(this.prefix + key);
  }
}
